import React, { useContext, useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { useNavigate } from "react-router";
//
import Box from "@mui/material/Box";
import useLocaleRoute from "../../../../../../common/hooks/useLocaleRoute";
import useModulePublic from "../../../../../hooks/useModulePublic";
import { StoreContext } from "../../../../../../store/StoreProvider";
import SelectionWithCheckbox from "../../../../../../common/components/input/SelectionWithCheckbox";
//
import Act from "../../../../../../store/actions";
import urls from "../../../../../../api/project/ApiUrls";

const AccordionDetailChildren = () => {
  // props

  // route,intl
  const intl = useIntl();
  const navigate = useNavigate();
  // store
  const [state, dispatch] = useContext(StoreContext);
  const { user, sna } = state;
  const { locale } = user;
  const { filter } = sna;
  const { nodeAuthorPreserve } = filter || {};
  // local state
  const [localOptions, setLocalOptions] = useState([]);
  const [selectVal, setSelectVal] = useState([]);

  // hooks
  const { handleLocaleRoute } = useLocaleRoute(
    locale,
    urls?.locale_lang?.LOCALE_DEFAULT
  );
  const { handlePublic } = useModulePublic();

  const optionsToSelectVal = (options) =>
    options.filter((item) => item.checked).map((item) => item.value);

  useEffect(() => {
    if (filter?.nodeAuthorPreserve?.change) {
      const newOptions = filter.nodeAuthorPreserve.change.map((item) => ({
        ...item,
        label: item.authorLabel,
        value: item.authorLabel,
      }));
      setLocalOptions(newOptions);
      setSelectVal(optionsToSelectVal(newOptions));
    }
  }, [filter]);

  const handleInputChange = (e) => {
    const { value } = e.target;

    const newOptions = localOptions.map((item) => ({
      ...item,
      checked: (value || []).indexOf(item.value) > -1,
    }));
    setLocalOptions(newOptions);
    setSelectVal(value);
    dispatch({
      type: Act.SNA_FILTER_NODE_AUTHOR_PRESERVE_CHANGE,
      payload: [...newOptions],
    });
  };

  return (
    <Box>
      <SelectionWithCheckbox
        options={localOptions}
        size="normal"
        darkMode
        fullWidth
        multiple
        value={selectVal}
        onChange={handleInputChange}
        inputProps={{}}
        MenuProps={{}}
      />
    </Box>
  );
};

export default AccordionDetailChildren;
